import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { Box, CircularProgress } from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = UserAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user?.uid) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // If user is logged in but has no Firestore profile, force them to Profile page
  // unless they are already there.
  if (user.profileExists === false && location.pathname !== '/profile') {
    return <Navigate to="/profile" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
